import * as React from 'react';
import { Alert, Button, Form, Spinner, Stack } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { NotifyInfo } from 'gossamer-front-end';
import { AuthShell, safeInternalPath } from './AuthShell';

export const WebsiteLoginPage = (props: {
  signIn: (email: string, password: string) => Promise<NotifyInfo>;
}): React.JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [message, setMessage] = React.useState<NotifyInfo>();
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsSubmitting(true);
    setMessage(undefined);
    try {
      const result = await props.signIn(email.trim(), password);
      setMessage(result);
      if (result[1] === 'success') {
        const requestedPath = new URLSearchParams(location.search).get('redirectToPath');
        navigate(safeInternalPath(requestedPath, '/'));
      }
    } catch (error) {
      setMessage([error instanceof Error ? error.message : 'Unable to log in.', 'danger']);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthShell title="Welcome back" introduction="Enter your Careerbook account details to continue.">
      {message && <Alert variant={message[1]}>{message[0]}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Stack gap={3}>
          <Form.Group controlId="login-email">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="login-password">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </Form.Group>
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
            <Link to="/auth/reset-password">Forgotten your password?</Link>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner className="me-2" animation="border" size="sm" />}
              Log in
            </Button>
          </div>
        </Stack>
      </Form>
      <hr className="my-4" />
      <p className="mb-0">
        New to Careerbook? <Link to="/auth/user-registration">Create an account</Link>.
      </p>
    </AuthShell>
  );
};
